export const bpOptions = [
  "120/80 (Normal)",
  "130/85 (Prehypertension)",
  "140/90 (Stage 1 Hypertension)",
  "160/100 (Stage 2 Hypertension)",
  "180/120 (Hypertensive Crisis)",
  "Low BP - Below 90/60",
  "Normal",
  "High",
];

export const pendingCommentsOptions = [
  'Waiting for equipment sterilization',
  'Awaiting surgical instruments',
  'Staff not available',
  'Patient preparation incomplete',
  'Pending anesthesia clearance',
];

export const unitsOptions = [
  '1 unit',
  '2 units',
  '3 units',
  '4 units',
  '5 units',
  '10 units',
];

export const dosageOptions = [
  '250 mg',
  '500 mg',
  '750 mg',
  '1 g',
  '2 g',
  '5 ml',
  '10 ml',
  '1 tablet',
  '2 tablets',
];

export const antibioticOptions = [
  'Amoxicillin',
  'Ciprofloxacin',
  'Azithromycin',
  'Doxycycline',
  'Cephalexin',
  'Clindamycin',
  'Metronidazole',
  'Erythromycin',
  'Penicillin',
  'Trimethoprim',
  'Cephalosporin',
];

export const allergyOptions = [
  'Penicillin',
  'Aspirin',
  'Latex',
  'Peanuts',
  'Shellfish',
  'Bee Stings',
  'Pollen',
  'Dust',
  'None',
];

export const preAnaestheticDrugs = [
  'Midazolam 2mg',
  'Fentanyl 50mcg',
  'Propofol 100mg',
  'Ketamine 50mg',
  'Atropine 0.5mg',
  'Dexmedetomidine 1mcg/kg',
  'None',
];

export const imagingTestOptions = [
  "X-Ray",
  "Ultrasound",
  "CT Scan",
  "MRI",
  "PET Scan",
  "Mammography",
  "Bone Density Scan",
  "Fluoroscopy",
  "Nuclear Medicine Scan",
  "Echocardiogram",
];

export const surgicalTeamOptions = [
  'Dr. Smith - Lead Surgeon',
  'Dr. Patel - Assistant Surgeon',
  'Nurse Johnson - Scrub Nurse',
  'Nurse Lee - Circulating Nurse',
  'Anesthesiologist Dr. Kumar',
  'Technician Garcia',
  'None',
];

export const oxygenLevelOptions = [
  "95%",
  "96%",
  "97%",
  "98%",
  "99%",
  "100%",
  "Below 90% (Low - Hypoxemia)",
];

export const temperatureOptions = [
  "35.0 °C (Hypothermia)",
  "36.0 °C (Low Normal)",
  "36.5 °C (Normal)",
  "37.0 °C (Normal)",
  "37.5 °C (Slightly Elevated)",
  "38.0 °C (Fever)",
  "39.0 °C (High Fever)",
  "40.0 °C (Very High Fever)",
];

export const medicationOptions = [
  "Paracetamol",
  "Ibuprofen",
  "Amoxicillin",
  "Metformin",
  "Aspirin",
  "Atorvastatin",
  "Lisinopril",
  "Omeprazole",
  "Salbutamol",
  "Levothyroxine",
];

export const heartRateOptions = [
  "50 (Bradycardia - Slow)",
  "60 (Normal Lower Limit)",
  "70 (Normal Resting)",
  "80 (Normal Resting)",
  "90 (Elevated)",
  "100 (Tachycardia - Fast)",
  "110 (High)",
  "120 (Very High)",
];

export const doctorGroups = {
  Cardiologists: [
    "Dr. John Smith",
    "Dr. Emily Johnson",
    "Dr. Michael Brown",
    "Dr. Sarah Davis",
    "Dr. William Wilson",
    "Dr. Linda Martinez"
  ],
  Neurologists: [
    "Dr. Robert Lee",
    "Dr. Patricia Taylor",
    "Dr. James Anderson",
    "Dr. Barbara Thomas",
    "Dr. David Jackson",
    "Dr. Susan White"
  ],
  Orthopedics: [
    "Dr. Richard Garcia",
    "Dr. Jennifer Harris",
    "Dr. Charles Clark",
    "Dr. Jessica Lewis",
    "Dr. Thomas Robinson",
    "Dr. Karen Walker"
  ],
  Dermatologists: [
    "Dr. Nancy Young",
    "Dr. Matthew Hall",
    "Dr. Donna Allen",
    "Dr. Steven King",
    "Dr. Michelle Wright",
    "Dr. George Scott"
  ],
  Gynecologists: [
    "Dr. Sandra Green",
    "Dr. Kevin Adams",
    "Dr. Laura Baker",
    "Dr. Mark Nelson",
    "Dr. Angela Carter",
    "Dr. Brian Mitchell"
  ],
  Pediatricians: [
    "Dr. Melissa Perez",
    "Dr. Eric Roberts",
    "Dr. Deborah Turner",
    "Dr. Jason Phillips",
    "Dr. Rebecca Campbell",
    "Dr. Andrew Parker"
  ]
};
